/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_H1Inputs */

const en_sorter_h1 = /** @type {(inputs: Sorter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Key Sorter`)
};

const ko_sorter_h1 = /** @type {(inputs: Sorter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 키 정렬기`)
};

const ja_sorter_h1 = /** @type {(inputs: Sorter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONキーソーター`)
};

/**
* | output |
* | --- |
* | "JSON Key Sorter" |
*
* @param {Sorter_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_h1 = /** @type {((inputs?: Sorter_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_h1(inputs)
	if (locale === "ko") return ko_sorter_h1(inputs)
	return ja_sorter_h1(inputs)
});